AgrimarketControllers.controller('userOfferController', ['$scope', '$rootScope', '$location', 'configurationFactory', 'offerService', 'enumFactory', '$routeParams', 'colonnesOffersFirmUser', 'colonnesOffersCommitmentUser', 'colonnesOffersFirmTc', 'colonnesOffersCommitmentTc', 'colonnesOffersOptionUser', 'colonnesOffersOptionTc', 'smsAlertService', 'colonnesOffersBlankContract', 'userService', 'colonnesOffersCommitmentSurfaceUser', 'colonnesOffersCommitmentSurfaceTc', 'colonnesOffersMultiCropsUser', 'colonnesOffersMultiCropsTc', 'parametersFactory', '$filter',
    function ($scope, $rootScope, $location, configurationFactory, offerService, enumFactory, $routeParams, colonnesOffersFirmUser, colonnesOffersCommitmentUser, colonnesOffersFirmTc, colonnesOffersCommitmentTc, colonnesOffersOptionUser, colonnesOffersOptionTc, smsAlertService, colonnesOffersBlankContract, userService, colonnesOffersCommitmentSurfaceUser, colonnesOffersCommitmentSurfaceTc, colonnesOffersMultiCropsUser, colonnesOffersMultiCropsTc, parametersFactory, $filter) {
        $scope.viewMode = $routeParams.typeOffer;
        $scope.idContractCommitment = $routeParams.idContractCommitment;
        $scope.quantity = $routeParams.quantity;
        $scope.targetPrice = $routeParams.targetPrice;
        $scope.idTypeFixationOnlyTargetPrice = $routeParams.idTypeFixationOnlyTargetPrice;
        $scope.idFirstComponentContractOrContractBase = $routeParams.idFirstComponentContractOrContractBase;
        $scope.enumFactory = enumFactory;
        $scope.enumTypeOffer = enumFactory.TypeOffer;
        $rootScope.offer = {};
        $scope.Product = { IdProduct: $rootScope.idProduct };
        $scope.Category = { Id: -1 };
        $scope.offersOpen = [];
        $scope.maxOffers = 10;
        $scope.pageNo = 1;
        $scope.allowUserToSubscribreToday = false;
        $scope.userNotSelected = $rootScope.CurrentUserRole === "TC" && ($rootScope.selectedClientFromTc === undefined || $rootScope.selectedClientFromTc === null);
        $scope.data = { reverse: false, sortKey: "Order" };
        $scope.IsModuleOptionActive = $rootScope.Modules.ModuleOption.Active;
        $scope.IsModuleBlankContractActive = $rootScope.Modules.ModuleContratVierge.Active;
        $scope.IsModuleMultiCropsActive = $rootScope.Modules.ModuleMultiCampagne.Active;
        $scope.enumTypeFixations = enumFactory.TypeFixations;
        $scope.lstProducts = [];
        $scope.lstCategories = [];
        var setFilters = true;
        $scope.Offer_SellLegendIcoIsVisible = $rootScope.editableObjectsFactory.EditableObjects.Offer_Sell.IsVisible || $rootScope.modeEdition;
        $scope.Offer_TargetPriceLegendIcoIsVisible = $rootScope.editableObjectsFactory.EditableObjects.Offer_TargetPrice.IsVisible || $rootScope.modeEdition;
        $scope.Offer_AlertLegendIcoIsVisible = $rootScope.editableObjectsFactory.EditableObjects.Offer_Alert.IsVisible || $rootScope.modeEdition;
        $scope.parambActivePriceOptimizer = parametersFactory.Parameters.bActivePriceOptimizer.Value === "1";
        $scope.paramOfferListingDisplayMode = parametersFactory.Parameters.OfferListingDisplayMode.Value;
        $scope.paramActiveOfferListingDisplayMode = parametersFactory.Parameters.bActiveOfferListingDisplayMode.Value;
        $rootScope.displayBlock =  $scope.paramActiveOfferListingDisplayMode && ($rootScope.displayBlock != undefined || $rootScope.displayBlock != null ? $rootScope.displayBlock : $scope.paramOfferListingDisplayMode == enumFactory.OfferListingDisplayModeValue.BLOC);
        $scope.User_OffersList_ActionBlock_Label_TakingPosition = $rootScope.editableObjectsFactory.EditableObjects.User_OffersList_ActionBlock_Label_TakingPosition.Content;
        $scope.User_OffersList_ActionBlock_Label_PreviousOffers = $rootScope.editableObjectsFactory.EditableObjects.User_OffersList_ActionBlock_Label_PreviousOffers.Content;
        $scope.User_OffersList_ActionBlock_Label_FollowingOffers = $rootScope.editableObjectsFactory.EditableObjects.User_OffersList_ActionBlock_Label_FollowingOffers.Content;
        var columnsAlwaysShow = ['LabelOffer','LabelProduct','EndValidity', 'QuantityLeft','GroupContacts'];//On liste les colonnes directement liés à l'offre et qui n'ont pas de lien direct avec des infos d'une échéance.
        $scope.autocompleteKey = 0;

        if (!$rootScope.paramSelectTcUserGlobally)
            $rootScope.selectedClientFromTcForSubscribe = undefined;
        else
            $scope.disabledPopUp = true;

        var AllowUserToSubscribreToday = function () {
            offerService.AllowUserToSubscribreToday(function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.allowUserToSubscribreToday = false;
                } else {
                    $scope.allowUserToSubscribreToday = data === "true";
                }
            });
        };

        var Init = function () {
            if ($rootScope.CurrentUserRole === "User") {
                // Offres fermes
                $scope.tableOfferFirmDataVisible = colonnesOffersFirmUser.data.DataVisible.split(',');
                $scope.tableOfferFirmLibelle = colonnesOffersFirmUser.data.ColumnName.split(',');

                // Offres Multi campagnes
                $scope.tableOfferMultiCropsDataVisible = colonnesOffersMultiCropsUser.data.DataVisible.split(',');
                $scope.tableOfferMultiCropsLibelle = colonnesOffersMultiCropsUser.data.ColumnName.split(',');

                // Offres d'engagements
                $scope.tableOfferCommitmentDataVisible = colonnesOffersCommitmentUser.data.DataVisible.split(',');
                $scope.tableOfferCommitmentLibelle = colonnesOffersCommitmentUser.data.ColumnName.split(',');

                // Offres d'option
                $scope.tableOfferOptionDataVisible = colonnesOffersOptionUser.data.DataVisible.split(',');
                $scope.tableOfferOptionLibelle = colonnesOffersOptionUser.data.ColumnName.split(',');

                // Offres d'engagements de surface
                $scope.tableOfferCommitmentSurfaceDataVisible = colonnesOffersCommitmentSurfaceUser.data.DataVisible.split(',');
                $scope.tableOfferCommitmentSurfaceLibelle = colonnesOffersCommitmentSurfaceUser.data.ColumnName.split(',');


            } else if ($rootScope.CurrentUserRole === "TC") {
                // Offres fermes
                $scope.tableOfferFirmDataVisible = colonnesOffersFirmTc.data.DataVisible.split(',');
                $scope.tableOfferFirmLibelle = colonnesOffersFirmTc.data.ColumnName.split(',');

                // Offres Multi campagnes
                $scope.tableOfferMultiCropsDataVisible = colonnesOffersMultiCropsTc.data.DataVisible.split(',');
                $scope.tableOfferMultiCropsLibelle = colonnesOffersMultiCropsTc.data.ColumnName.split(',');

                // Offres d'engagements
                $scope.tableOfferCommitmentDataVisible = colonnesOffersCommitmentTc.data.DataVisible.split(',');
                $scope.tableOfferCommitmentLibelle = colonnesOffersCommitmentTc.data.ColumnName.split(',');

                // Offres d'option
                $scope.tableOfferOptionDataVisible = colonnesOffersOptionTc.data.DataVisible.split(',');
                $scope.tableOfferOptionLibelle = colonnesOffersOptionTc.data.ColumnName.split(',');

                // Offres contrat vierge
                $scope.tableOfferBlankContractDataVisible = colonnesOffersBlankContract.data.DataVisible.split(',');
                $scope.tableOfferBlankContractLibelle = colonnesOffersBlankContract.data.ColumnName.split(',');
                $scope.tableOfferBlankDataVisibleKey = $scope.GetOnlyKeyForTableDataVisible($scope.tableOfferBlankContractDataVisible);

                // Offres d'engagements de surface
                $scope.tableOfferCommitmentSurfaceDataVisible = colonnesOffersCommitmentSurfaceTc.data.DataVisible.split(',');
                $scope.tableOfferCommitmentSurfaceLibelle = colonnesOffersCommitmentSurfaceTc.data.ColumnName.split(',');
            }

            if (!$scope.userNotSelected) {
                var index = $scope.tableOfferFirmDataVisible.indexOf('GroupContacts;liste');
                if (index !== -1) {
                    $scope.tableOfferFirmDataVisible.splice(index, 1);
                    $scope.tableOfferFirmLibelle.splice(index, 1);
                }
            }
            $scope.tableOfferFirmDataVisibleKey = $scope.GetOnlyKeyForTableDataVisible($scope.tableOfferFirmDataVisible);
            $scope.tableOfferMultiCropDataVisibleKey = $scope.GetOnlyKeyForTableDataVisible($scope.tableOfferMultiCropsDataVisible);
            $scope.tableOfferCommitmentDataVisibleKey = $scope.GetOnlyKeyForTableDataVisible($scope.tableOfferCommitmentDataVisible);
            $scope.tableOfferOptionDataVisibleKey = $scope.GetOnlyKeyForTableDataVisible($scope.tableOfferOptionDataVisible);
            $scope.tableOfferCommitmentSurfaceDataVisibleKey = $scope.GetOnlyKeyForTableDataVisible($scope.tableOfferCommitmentSurfaceDataVisible);

            $scope.GetOffersOpen();
            AllowUserToSubscribreToday();
        };

        $scope.DisplayChange = function (displayBlock) {
			$rootScope.displayBlock = !displayBlock;
		};

        $scope.AsChangedCrop = function () {
            // On reset les filtres
            setFilters = true;
            $scope.Product.IdProduct = null;
            $scope.Category.Id = -1;
            $scope.pageNo = 1;
            $scope.GetOffersOpen();
        };

        $scope.AsChangedProduct = function () {
            $scope.pageNo = 1;
            $scope.GetOffersOpen();
        };

        $scope.AsChangedCategory = function () {
            $scope.pageNo = 1;
            $scope.GetOffersOpen();
        };

        $scope.GoToSubscribe = function () {
            if ($scope.offerSelected.IdTypeOffer === $scope.enumTypeOffer.Engagement || $scope.offerSelected.IdTypeOffer === $scope.enumTypeOffer.EngagementSurface)
                $rootScope.idTypeCommitmentSelected = $scope.offerSelected.IdTypeCommitment;
            else
                $rootScope.idTypeCommitmentSelected = null;

            switch ($scope.idTypeFixation) {
                case enumFactory.TypeFixations.Base.IdTypeFixation:
                    $location.path('/user/subscribe/contractBase/' + ($scope.idContractCommitment ? $scope.idContractCommitment : '') + '/' + ($scope.idFirstComponentContractOrContractBase ? $scope.idFirstComponentContractOrContractBase : '') + '/' + ($scope.quantity ? $scope.quantity : '') + '/' + ($scope.targetPrice ? $scope.targetPrice : ''));
                    break;
                case enumFactory.TypeFixations.Future.IdTypeFixation:
                case enumFactory.TypeFixations.GlobalPrice.IdTypeFixation:
                    $location.path('/user/subscribe/contractFirm/' + ($scope.idContractCommitment ? $scope.idContractCommitment : '') + '/' + $scope.idTypeFixation + '/' + ($scope.idFirstComponentContractOrContractBase ? $scope.idFirstComponentContractOrContractBase : '') + '/' + ($scope.quantity ? $scope.quantity : '') + '/' + ($scope.targetPrice ? $scope.targetPrice : ''));
                    break;
                default:
                    if ($scope.offerSelected.IdTypeOffer === $scope.enumTypeOffer.EngagementSurface)
                        $location.path('/user/subscribe/contractSurfaceCommitment');
                    else
                        $location.path('/user/subscribe/contractCommitment');
                    break;
            }
        };

        $scope.GoToSubscribeOption = function (offer, idExpiry, idTypeOrder) {
            $rootScope.offerSelected = {
                IdOfferSelected: offer.IdOffer,
                IdProductSelected: offer.IdProduct,
                IdExpirySelected: idExpiry,
                IdTypeOptionSelected: offer.IdTypeOption,
                IdTypeOrderSelected: idTypeOrder,
                IdCropSelected: $rootScope.crop.IdCrop
            };
            $location.path('/user/subscribe/contractoption/');
        };

        $scope.GoToSubscribeBlankContract = function () {
            $location.path('/user/subscribe/contractBlank/');
        };

        $scope.GoToSubscribeMultiCropsContract = function () {
            $location.path('/user/subscribe/contractMultiCrops/');
        };

        $scope.SubscribeActionClick = function (offer, idExpiry, idTypeOrder, idTypeFixation, openPopUp) {
            // Reset des champs liés à la popup
            $scope.searchTextClientFromTc = '';
            $scope.autocompleteKey++; // Force le re-render du composant

            if (offer) {
                $rootScope.idOfferSelected = !offer.IdOffer ? offer.IdOfferParent : offer.IdOffer;
                $scope.offerSelected = offer;
                $rootScope.idExpirySelected = idExpiry;
            }
            if (idTypeOrder)
                $rootScope.idTypeOrderSelected = idTypeOrder;
            if (idTypeFixation)
                $scope.idTypeFixation = idTypeFixation;

            if ($scope.disabledPopUp || $rootScope.CurrentUserRole === "User") { // Ticket #229333 : variable permettant de répondre à un bug rencontré par un client, la pop up ne se réaffiche pas si l'utilisateur choisit un agri puis ferme la modal sans cliquer sur suivant
                if ($scope.offerSelected.IdTypeOffer === $scope.enumTypeOffer.Option)
                    $scope.GoToSubscribeOption();
                else if ($scope.offerSelected.IdTypeOffer === $scope.enumTypeOffer.ContratVierge)
                    $scope.GoToSubscribeBlankContract();
                else if ($scope.offerSelected.IdTypeOffer === $scope.enumTypeOffer.MultiCampagne)
                    $scope.GoToSubscribeMultiCropsContract();
                else
                    $scope.GoToSubscribe();
            }
            else {
                $rootScope.selectedClientFromTcForSubscribe = undefined;
                openPopUp();
            }
        };

        $scope.SubmitPopUpTcUsers = function () {
            userService.SaveClientSelectedFromTC($rootScope.selectedClientFromTcForSubscribe.IdUser, false, function (data, status) {
                if (status === 400)
                    $scope.errorMessage = data[0].errors[0].Message;
                else {
                    $scope.disabledPopUp = true;
                    $scope.SubscribeActionClick();
                }
            });
        };

        $scope.SetSelectedClientFromTc = function (client) {
            $rootScope.selectedClientFromTcForSubscribe = client;
        };

        $scope.GetOffersOpen = function () {
            $scope.loading = true;
            offerService.GetDataOfferPaginateWithFilter($rootScope.crop.IdCrop, $routeParams.typeOffer, $scope.Product.IdProduct ? $scope.Product.IdProduct : '', ($scope.Category.Id || $scope.Category.Id == 0 ? $scope.Category.Id : ''), $scope.idContractCommitment ? $scope.idContractCommitment : '', $scope.maxOffers, $scope.pageNo, $scope.data.sortKey, $scope.data.reverse, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = data[0].errors[0].Message;
                } else {
                    $scope.offersOpen = [];
                    $scope.dataOfferExpiriesoffersOpen = [];

                    data.LstOfferOpenVm.forEach(function (item) {
                        
                        item.AllExpiries = [];
                        item.ExpirySelectedInDisplayBlock = {};
                        item.IdExpirySelectedInDisplayBlock = 0;
                        item.showAllExpiryOffer = true;
                        item.urlAttachment = configurationFactory.Url['Api'] + 'Upload/GetInlineAttachment?p=' + item.AttachmentPrivateLabel;

                        var showLoaderPriceOptimizer = item.IdTypeOffer === $scope.enumTypeOffer.Ferme && $scope.parambActivePriceOptimizer && !item.ActiveSubscribeMultiExpiries;
                        item.showLoader = showLoaderPriceOptimizer;

                        $scope.SetActionsOffer(item);

                        if (!item.ActiveSubscribeMultiExpiries && item.QuotesExpiryOfferManagerVM && item.QuotesExpiryOfferManagerVM.length > 0) {
                            item.QuotesExpiryOfferManagerVM.forEach(function (exp) {
                                exp.showLoader = showLoaderPriceOptimizer;
                                $scope.SetActionsExpiry(exp, item);
                            });
                        }
                        $scope.offersOpen.push(item);

                        if (showLoaderPriceOptimizer) {
                            $scope.GetDataForOfferExpiriesWithPriceOptimizer(item);
                        }
                    
                        if (!showLoaderPriceOptimizer && item.QuotesFirstExpiryOfferManagerVM) {
                            $scope.SetAllExpiries(item);
                            $scope.SetExpirySelectedInDisplayBlock(item);
                        }
                    });

                    $scope.total = data.Total;
                    $scope.isAlertSmsActive = data.IsAlertSmsActive;

                    if (setFilters) {
                        $scope.lstProducts = data.LstProduct;
                        $scope.lstCategories = data.LstCategory;
                        setFilters = false;
                    }

                    $scope.loading = false;
                }
            });
        };

        $scope.GetDataForOfferExpiriesWithPriceOptimizer = function (offer) {
            offerService.GetOfferOrExpiryBestPrice(offer.IdOffer, null, $scope.idContractCommitment, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = data[0].errors[0].Message;
                } else {
                    var oldIdFirstExpiry = offer.IdFirstExpiry;
                    var bestPriceWithSymbol = data.BestPrice.toString() + " " + data.Symbol;

                    if (data.IdBestExpiry == oldIdFirstExpiry) { //Si le meilleur prix est bien celui de la première échéance alors on doit juste mettre à jour le prix global.
                        offer.GlobalPriceWithCurrencyUnit = bestPriceWithSymbol;
                        offer.QuotesFirstExpiryOfferManagerVM.PriceUserWithCurrencyUnit = bestPriceWithSymbol;
                        offer.showLoader = false;
                    }
                    else { // Si la première échéance n'est pas celle avec le meilleur prix alors il va falloir mettre la bonne sur la première ligne et mettre celle qui était en première ligne en première position dans le listing des échéances.
                        offer.QuotesFirstExpiryOfferManagerVM.showLoader = true;
                        if(!offer.ActiveSubscribeMultiExpiries) {
                            offer.QuotesExpiryOfferManagerVM.unshift(offer.QuotesFirstExpiryOfferManagerVM);//On ajoute l'échéance de la première ligne dans la liste des échéances en première position
                            var newFirstExpiry = $filter('filter')(offer.QuotesExpiryOfferManagerVM, { IdExpiry: data.IdBestExpiry }, true)[0];
                            newFirstExpiry.PriceUserWithCurrencyUnit = bestPriceWithSymbol;
                            offer.QuotesFirstExpiryOfferManagerVM = newFirstExpiry;
                            $scope.UpdateExpiryFirstLineInfo(offer, newFirstExpiry, bestPriceWithSymbol);
                        }

                        var indexQuoteExpiryInFirstLine = offer.QuotesExpiryOfferManagerVM.findIndex(function (expiry){return expiry.IdExpiry == data.IdBestExpiry;});
                        if (!offer.ActiveSubscribeMultiExpiries && indexQuoteExpiryInFirstLine > -1) {
                            offer.QuotesExpiryOfferManagerVM.splice(indexQuoteExpiryInFirstLine, 1);//On supprime l'échéance qui a le meilleur prix de la liste des échéances car on va la passer sur la première ligne au noveau des infos de l'offre.
                        }
                    }

                    if(!offer.ActiveSubscribeMultiExpiries) {
                        offer.QuotesExpiryOfferManagerVM.forEach(function (exp) {
                            offerService.GetOfferOrExpiryBestPrice(offer.IdOffer, exp.IdExpiry, $scope.idContractCommitment, function (dataExpiry, status) {
                                if (status !== null) {
                                    if (status === 400)
                                        $scope.errorMessage = dataExpiry[0].errors[0].Message;
                                } else {
                                        exp.PriceUserWithCurrencyUnit = dataExpiry.BestPrice.toString() + " " + dataExpiry.Symbol;
    
                                        if (exp.IdExpiry == oldIdFirstExpiry) { //On set les actions pour l'échéance qui était avant sur la première ligne
                                            $scope.SetActionsExpiry(exp, offer);
                                        }
                                        exp.showLoader = false;
                                }
                            });
                        });
                    }

                    $scope.SetAllExpiries(offer);
                    $scope.SetExpirySelectedInDisplayBlock(offer);
                }
            });
        };
        $scope.SetAllExpiries = function(offer) {
            offer.AllExpiries.push(offer.QuotesFirstExpiryOfferManagerVM);
            if(!offer.ActiveSubscribeMultiExpiries) {
                offer.QuotesExpiryOfferManagerVM.forEach(function (exp) {
                    offer.AllExpiries.push(exp);
                });
            }
        };

        $scope.SetActionsOffer = function(offer) {
            var actionFuturePrice = offer.MarketPrice > 0;
            var actionGlobalPrice = offer.GlobalPrice > 0;

            if ($rootScope.parambActivedSubscribeOfferWithZeroPrice == "1") {
                if (offer.MarketPrice == 0) actionFuturePrice = offer.MarketPrice == 0;
                if (offer.GlobalPrice == 0) actionGlobalPrice = offer.GlobalPrice == 0;
            }

            offer.showFixationBaseActionSold = offer.BasePriceWithCurrencyUnit && offer.CanSoldBase && offer.TypeFixationTypeOrders.SoldBase;
            offer.showFixationBaseActionTargetPrice = offer.BasePriceWithCurrencyUnit && offer.CanTargetPriceBase && offer.TypeFixationTypeOrders.TargetPriceBase;
            offer.showFixationBaseActions = offer.showFixationBaseActionSold || offer.showFixationBaseActionTargetPrice;

            offer.showFixationFuturePriceActionSold = actionFuturePrice && !offer.CanNotSubscribeFuture && offer.CanSold && offer.TypeFixationTypeOrders.SoldFuture;
            offer.showFixationFuturePriceActionTargetPrice = actionFuturePrice && !offer.CanNotSubscribeFuture && offer.CanTargetPrice && offer.TypeFixationTypeOrders.TargetPriceFuture;
            offer.showFixationFuturePriceActions = offer.showFixationFuturePriceActionSold || offer.showFixationFuturePriceActionTargetPrice;

            offer.showFixationGlobalPriceActionSold = actionGlobalPrice && offer.CanSold && offer.TypeFixationTypeOrders.SoldGlobalPrice;
            offer.showFixationGlobalPriceActionTargetPrice = actionGlobalPrice && offer.CanTargetPrice && offer.TypeFixationTypeOrders.TargetPriceGlobalPrice;
            offer.showFixationGlobalPriceActions = offer.showFixationGlobalPriceActionSold || offer.showFixationGlobalPriceActionTargetPrice;
        };

        $scope.SetActionsExpiry = function(expriy, offer) {
            expriy.showFixationBaseActionSold = expriy.BasePriceWithCurrencyUnit && expriy.CanSoldBase && offer.TypeFixationTypeOrders.SoldBase;
            expriy.showFixationBaseActionTargetPrice = expriy.BasePriceWithCurrencyUnit && expriy.CanTargetPriceBase && offer.TypeFixationTypeOrders.TargetPriceBase;
            expriy.showFixationBaseActions = expriy.showFixationBaseActionSold || expriy.showFixationBaseActionTargetPrice;

            expriy.showFixationFuturePriceActionSold = expriy.Price > 0 && !offer.CanNotSubscribeFuture && expriy.CanSold && offer.TypeFixationTypeOrders.SoldFuture;
            expriy.showFixationFuturePriceActionTargetPrice = expriy.Price > 0 && !offer.CanNotSubscribeFuture && expriy.CanTargetPrice && offer.TypeFixationTypeOrders.TargetPriceFuture;
            expriy.showFixationFuturePriceActions = expriy.showFixationFuturePriceActionSold || expriy.showFixationFuturePriceActionTargetPrice;

            expriy.showFixationGlobalPriceActionSold = expriy.PriceUser > 0 && expriy.CanSold && offer.TypeFixationTypeOrders.SoldGlobalPrice;
            expriy.showFixationGlobalPriceActionTargetPrice = expriy.PriceUser > 0 && expriy.CanTargetPrice && offer.TypeFixationTypeOrders.TargetPriceGlobalPrice;
            expriy.showFixationGlobalPriceActions = expriy.showFixationGlobalPriceActionSold || expriy.showFixationGlobalPriceActionTargetPrice;
        };

        $scope.GetColumnAlwaysShowDataForLoader = function(columnName) {
            var showColumnData = columnsAlwaysShow.includes(columnName);
            return showColumnData;//Retourne true si on peut afficher la colonne même si il y a un loader en cours (en gros si c'est une info qui concerne l'offre et non l'échéance)
        };
        
        $scope.ShowLoaderForColumn = function(columnName) {
            var getFirstColumnForShowLoader = $filter('filter')($scope.tableOfferFirmDataVisible, function (item) {return !columnsAlwaysShow.includes(item);}, true)[0];//On récupére la première colonne qui dépend d'une échéance dans lequel on doit avoir un loader
            if (columnName == getFirstColumnForShowLoader) {
                return true;//Retourne true si on est sur la première colonne lié à une échéance
            }
            else {
                return false;
            }
        };

        $scope.UpdateExpiryFirstLineInfo = function (offer, newFirstExpiry, bestPrice) {
            offer.IdFirstExpiry = newFirstExpiry.IdExpiry;
            offer.LabelExpiry = newFirstExpiry.LabelExpiry;
            offer.BasePrice = newFirstExpiry.BasePrice;
            offer.MarketPrice = newFirstExpiry.Price;
            offer.CanNotSubscribeFuture = newFirstExpiry.CanNotSubscribeFuture;
            offer.LimitMin = newFirstExpiry.LimitMin;
            offer.LimitMax = newFirstExpiry.LimitMax;
            offer.DeliveryStartDate = newFirstExpiry.DeliveryStartDate;
            offer.DeliveryEndDate = newFirstExpiry.DeliveryEndDate;
            offer.PaymentDate = newFirstExpiry.PaymentDate;
            offer.BasePriceWithCurrencyUnit = newFirstExpiry.BasePriceWithCurrencyUnit;
            offer.MarketPriceWithCurrencyUnit = newFirstExpiry.MarketPriceWithCurrencyUnit;
            offer.PriceUserWithCurrencyUnit = newFirstExpiry.PriceUserWithCurrencyUnit;
            offer.CurrencyUnitFinal = newFirstExpiry.CurrencyUnitFinal;
            offer.CurrencyUnitForComponents = newFirstExpiry.CurrencyUnitForComponents;
            offer.DecimalCurrencyUnitForComponents = newFirstExpiry.DecimalCurrencyUnitForComponents;
            offer.DecimalCurrencyUnitFinal = newFirstExpiry.DecimalCurrencyUnitFinal;
            offer.CanSold = newFirstExpiry.CanSold;
            offer.CanSoldBase = newFirstExpiry.CanSoldBase;
            offer.CanTargetPrice = newFirstExpiry.CanTargetPrice;
            offer.CanTargetPriceBase = newFirstExpiry.CanTargetPriceBase;
            offer.GlobalPriceWithCoeffConverted = newFirstExpiry.GlobalPriceConverted;
            offer.GlobalPrice = newFirstExpiry.PriceUser;
            offer.GlobalPriceWithCurrencyUnit = bestPrice;
            $scope.SetActionsOffer(offer);
            offer.showLoader = false;
         };

        $scope.SetExpirySelectedInDisplayBlock = function (offer) {
            offer.ExpirySelectedInDisplayBlock = offer.AllExpiries[0];
            offer.IdExpirySelectedInDisplayBlock = offer.ExpirySelectedInDisplayBlock.IdExpiry;
        };

        $scope.SelectExpiryInDispalyBlock = function (offer, idExpirySelected) {
            var expirySelected = $filter('filter')(offer.AllExpiries, { IdExpiry: idExpirySelected }, true)[0];
            offer.ExpirySelectedInDisplayBlock = expirySelected;
        };

         $scope.GetOnlyKeyForTableDataVisible = function (tableDataVisible) {
            var arrayKey = [];
            tableDataVisible.forEach(function (dataVisible) {
                arrayKey.push(dataVisible.split(';')[0]);
            });
            return arrayKey;
        };

        $scope.Sort = function (sortKey, reverse) {
            $scope.data.sortKey = sortKey;
            $scope.data.reverse = reverse;
            $scope.GetOffersOpen();
        };

        $scope.GetData = function (pageNo) {
            $scope.pageNo = pageNo;
            $scope.GetOffersOpen();
        };

        $scope.SetLimitsAlertSmsPopUp = function (idExpiry, limitMin, limitMax, openPopUp) {
            $scope.popupSmsAlertErrorMessage = "";
            offerService.GetOfferPrice(idExpiry, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = data[0].errors[0].Message;
                } else {
                    $scope.expirySelected = {
                        idExpiry: idExpiry,
                        price: data.FinalPrice,
                        symbol: data.Symbol,
                        limitMin: limitMin,
                        limitMax: limitMax
                    };
                    openPopUp();
                }
            });

        };

        $scope.ChkSmsAlertIsValid = function () {
            $scope.popupSmsAlertErrorMessage = smsAlertService.CheckSmsAlertIsValid($scope.expirySelected.limitMax, $scope.expirySelected.limitMin, $scope.expirySelected.price);

            if ($scope.popupSmsAlertErrorMessage !== "") {
                return false;
            }
            else {
                return true;
            }
        };

        $scope.SaveSmsAlertLimit = function () {
            if (!$scope.expirySelected.limitMin)
                $scope.expirySelected.limitMin = "";
            if (!$scope.expirySelected.limitMax)
                $scope.expirySelected.limitMax = "";

            smsAlertService.SaveUserExpirySmsLimits($scope.expirySelected.idExpiry, $scope.expirySelected.limitMin, $scope.expirySelected.limitMax, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    Init();
                }
            });
        };

        $rootScope.onRefresh = function () { Init(); };
        Init();
    }]);
